// containers/TotalSalesMonth.jsx
import React, { useEffect, useState } from "react";
import TotalSalesMonthDisplay from "../../components/VentasDatos/TotalSalesMonthDisplay";
import { getUser } from "../../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function TotalSalesMonth() {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    const fetchTotal = async () => {
      const user = getUser();
      try {
        const res = await fetch(`${URL}/api/sales/datos/summary/monthly-sales-total/`, {
          headers: {
            "x-empresa-id": user?.empresa_id,
          },
        });
        if (!res.ok) throw new Error("Error al obtener la facturación total");
        const data = await res.json();
        setTotal(data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchTotal();
  }, []);

  return <TotalSalesMonthDisplay total={total} />;
}
